module.exports = __webpack_public_path__ + "img/info20@2x.0d8a8e5d.png";